import {
  INTEGRATION_MOVEMENTS_SET_LOADING,
  INTEGRATION_MOVEMENTS_SET_ERROR,
  INTEGRATION_MOVEMENTS_SET_INTEGRATION_MOVEMENTS,
  INTEGRATION_MOVEMENTS_SET_INTEGRATION_MOVEMENT,
  INTEGRATION_MOVEMENTS_SET_PAGINATION,
  INTEGRATION_MOVEMENTS_FETCH_INTEGRATION_MOVEMENTS,
  INTEGRATION_MOVEMENTS_FETCH_INTEGRATION_MOVEMENT,
  INTEGRATION_MOVEMENTS_CLEAR_ERROR,
  INTEGRATION_MOVEMENTS_GET_INTEGRATION_MOVEMENTS,
  INTEGRATION_MOVEMENTS_GET_INTEGRATION_MOVEMENT,
  INTEGRATION_MOVEMENTS_GET_PAGINATION,
  INTEGRATION_MOVEMENTS_GET_LOADING,
  INTEGRATION_MOVEMENTS_GET_ERROR,
  INTEGRATION_MOVEMENTS_SET_INTEGRATION_MOVEMENT_TYPES,
  INTEGRATION_MOVEMENTS_FETCH_INTEGRATION_MOVEMENT_TYPES,
  INTEGRATION_MOVEMENTS_GET_INTEGRATION_MOVEMENT_TYPES,
  INTEGRATION_MOVEMENTS_SET_INTEGRATION_MOVEMENT_STATES,
  INTEGRATION_MOVEMENTS_FETCH_INTEGRATION_MOVEMENT_STATES,
  INTEGRATION_MOVEMENTS_GET_INTEGRATION_MOVEMENT_STATES,
  INTEGRATION_MOVEMENTS_SET_INTEGRATION_MOVEMENT_AS_MANAGED,
  INTEGRATION_MOVEMENTS_SET_INTEGRATION_MOVEMENT_AS_NOT_CONSIDERED
} from './types';
import { integrationMovementService } from '@/network';
import {
  handleAsyncAction,
  createAsyncState,
  createAsyncMutations
} from '@/utils/helpers/store';

const state = {
  integrationMovements: [],
  integrationMovementTypes: [],
  integrationMovementStates: [],
  integrationMovement: {},
  pagination: {
    page: 1,
    pages: null,
    size: 10,
    count: 0
  },
  ...createAsyncState([
    'fetchIntegrationMovements',
    'fetchIntegrationMovementTypes',
    'fetchIntegrationMovementStates',
    'fetchIntegrationMovement',
    'setIntegrationMovementAsManaged',
    'setIntegrationMovementAsNotConsidered'
  ])
};

const mutations = {
  ...createAsyncMutations(
    INTEGRATION_MOVEMENTS_SET_LOADING,
    INTEGRATION_MOVEMENTS_SET_ERROR
  ),
  [INTEGRATION_MOVEMENTS_SET_INTEGRATION_MOVEMENTS](
    state,
    integrationMovements
  ) {
    state.integrationMovements = integrationMovements;
  },
  [INTEGRATION_MOVEMENTS_SET_INTEGRATION_MOVEMENT_TYPES](
    state,
    integrationMovementTypes
  ) {
    state.integrationMovementTypes = integrationMovementTypes;
  },
  [INTEGRATION_MOVEMENTS_SET_INTEGRATION_MOVEMENT_STATES](
    state,
    integrationMovementStates
  ) {
    state.integrationMovementStates = integrationMovementStates;
  },
  [INTEGRATION_MOVEMENTS_SET_INTEGRATION_MOVEMENT](state, integrationMovement) {
    state.integrationMovement = integrationMovement;
  },
  [INTEGRATION_MOVEMENTS_SET_PAGINATION](state, pagination) {
    state.pagination = pagination;
  }
};

const actions = {
  async [INTEGRATION_MOVEMENTS_FETCH_INTEGRATION_MOVEMENTS](
    { commit },
    {
      companyIds,
      holdingName,
      subholdingName,
      brokerId,
      rut,
      movementTypeId,
      stateIds,
      fullname,
      movementStartDate,
      movementEndDate,
      createdStartDate,
      createdEndDate,
      page,
      size
    }
  ) {
    return handleAsyncAction({
      commit,
      actionType: 'fetchIntegrationMovements',
      errorMessage:
        'Ocurrió un error al obtener los movimientos de integración',
      asyncOperation: async () => {
        const hasPagination = size > 0;

        const query = {
          companyIds,
          holdingName,
          subholdingName,
          brokerId,
          rut,
          movementTypeId,
          stateIds,
          fullname,
          movementStartDate,
          movementEndDate,
          createdStartDate,
          createdEndDate
        };

        let integrationMovements;
        if (hasPagination) {
          const { rows, ...pagination } =
            await integrationMovementService.findAll({
              ...query,
              page,
              size
            });
          integrationMovements = rows;
          commit(INTEGRATION_MOVEMENTS_SET_PAGINATION, pagination);
        } else {
          integrationMovements = await integrationMovementService.findAll({
            ...query
          });
        }
        commit(
          INTEGRATION_MOVEMENTS_SET_INTEGRATION_MOVEMENTS,
          integrationMovements
        );
        return integrationMovements;
      },
      setLoading: INTEGRATION_MOVEMENTS_SET_LOADING,
      setError: INTEGRATION_MOVEMENTS_SET_ERROR
    });
  },

  async [INTEGRATION_MOVEMENTS_FETCH_INTEGRATION_MOVEMENT_TYPES]({ commit }) {
    return handleAsyncAction({
      commit,
      actionType: 'fetchIntegrationMovementTypes',
      errorMessage:
        'Ocurrió un error al obtener los tipos de movimientos de integración',
      asyncOperation: async () => {
        const integrationMovementTypes =
          await integrationMovementService.getTypes();
        commit(
          INTEGRATION_MOVEMENTS_SET_INTEGRATION_MOVEMENT_TYPES,
          integrationMovementTypes
        );
        return integrationMovementTypes;
      },
      setLoading: INTEGRATION_MOVEMENTS_SET_LOADING,
      setError: INTEGRATION_MOVEMENTS_SET_ERROR
    });
  },

  async [INTEGRATION_MOVEMENTS_FETCH_INTEGRATION_MOVEMENT_STATES]({ commit }) {
    return handleAsyncAction({
      commit,
      actionType: 'fetchIntegrationMovementStates',
      errorMessage:
        'Ocurrió un error al obtener los estados de movimientos de integración',
      asyncOperation: async () => {
        const integrationMovementStates =
          await integrationMovementService.getStates();
        commit(
          INTEGRATION_MOVEMENTS_SET_INTEGRATION_MOVEMENT_STATES,
          integrationMovementStates
        );
        return integrationMovementStates;
      },
      setLoading: INTEGRATION_MOVEMENTS_SET_LOADING,
      setError: INTEGRATION_MOVEMENTS_SET_ERROR
    });
  },

  async [INTEGRATION_MOVEMENTS_FETCH_INTEGRATION_MOVEMENT]({ commit }, { id }) {
    return handleAsyncAction({
      commit,
      actionType: 'fetchIntegrationMovement',
      errorMessage: 'Ocurrió un error al obtener el movimiento de integración',
      asyncOperation: async () => {
        const integrationMovement = await integrationMovementService.findOne(
          id
        );
        commit(
          INTEGRATION_MOVEMENTS_SET_INTEGRATION_MOVEMENT,
          integrationMovement
        );
        return integrationMovement;
      },
      setLoading: INTEGRATION_MOVEMENTS_SET_LOADING,
      setError: INTEGRATION_MOVEMENTS_SET_ERROR
    });
  },

  async [INTEGRATION_MOVEMENTS_SET_INTEGRATION_MOVEMENT_AS_MANAGED](
    { commit },
    { id, comment }
  ) {
    return handleAsyncAction({
      commit,
      actionType: 'setIntegrationMovementAsManaged',
      errorMessage:
        'Ocurrió un error al marcar el movimiento de integración como gestionado',
      asyncOperation: async () => {
        const integrationMovement =
          await integrationMovementService.setAsManaged(id, { comment });
        return integrationMovement;
      },
      setLoading: INTEGRATION_MOVEMENTS_SET_LOADING,
      setError: INTEGRATION_MOVEMENTS_SET_ERROR
    });
  },

  async [INTEGRATION_MOVEMENTS_SET_INTEGRATION_MOVEMENT_AS_NOT_CONSIDERED](
    { commit },
    { id, comment }
  ) {
    return handleAsyncAction({
      commit,
      actionType: 'setIntegrationMovementAsNotConsidered',
      errorMessage:
        'Ocurrió un error al marcar el movimiento de integración como no considerado',
      asyncOperation: async () => {
        const integrationMovement =
          await integrationMovementService.setAsNotConsidered(id, { comment });
        return integrationMovement;
      },
      setLoading: INTEGRATION_MOVEMENTS_SET_LOADING,
      setError: INTEGRATION_MOVEMENTS_SET_ERROR
    });
  },

  [INTEGRATION_MOVEMENTS_CLEAR_ERROR]({ commit }, { type }) {
    commit(INTEGRATION_MOVEMENTS_SET_ERROR, {
      type,
      value: null
    });
  }
};

const getters = {
  [INTEGRATION_MOVEMENTS_GET_INTEGRATION_MOVEMENT]: (state) =>
    state.integrationMovement,
  [INTEGRATION_MOVEMENTS_GET_INTEGRATION_MOVEMENTS]: (state) =>
    state.integrationMovements,
  [INTEGRATION_MOVEMENTS_GET_INTEGRATION_MOVEMENT_TYPES]: (state) =>
    state.integrationMovementTypes,
  [INTEGRATION_MOVEMENTS_GET_INTEGRATION_MOVEMENT_STATES]: (state) =>
    state.integrationMovementStates,
  [INTEGRATION_MOVEMENTS_GET_PAGINATION]: (state) => state.pagination,
  [INTEGRATION_MOVEMENTS_GET_LOADING]: (state) => state.loading,
  [INTEGRATION_MOVEMENTS_GET_ERROR]: (state) => state.error
};

export default {
  state,
  mutations,
  actions,
  getters
};
